import React, { useEffect, useState } from "react";
import { Table, Button, message } from "antd";
import api from "../api";
import { useNavigate } from "react-router-dom";
import DetalleProcesoModal from "../components/DetalleProcesoModal";

const ProcesosPage = () => {
  const navigate = useNavigate();
  const [procesos, setProcesos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedProceso, setSelectedProceso] = useState(null);

  const getProcesos = async () => {
    try {
      setLoading(true);
      const res = await api.get("/proceso", { params: { page: 1, limit: 50000 } });
      setProcesos(res.data.data || []);
    } catch (err) {
      message.error("Error al obtener procesos");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getProcesos();
  }, []);

  const showDetails = (proceso) => {
    setSelectedProceso(proceso);
    setOpenModal(true);
  };

  return (
    <>
      <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16 }}>Procesos</h2>
      <Table
        dataSource={procesos}
        loading={loading}
        rowKey="idproceso"
        columns={[
          { title: "Secuencial", dataIndex: "secuencial" },
          { title: "Productor", dataIndex: "productorNombre" },
          { title: "Exportador", dataIndex: "exportadorNombre" },
          { title: "Producto", dataIndex: "producto" },
          { title: "Estado", dataIndex: "estado" },
          { title: "Fecha Inicio", dataIndex: "fechaInicio" },
          {
            title: "Acciones",
            render: (_, record) => (
              <Button type="link" onClick={() => navigate(`/procesos/${record.idproceso}`)}>
                Ver Detalle
              </Button>
            ),
          }
        ]}
        scroll={{ x: 'max-content' }}
      />
    </>
  );
};

export default ProcesosPage;
